<script lang="ts">
    import { interpolateHeadAndBody } from './helpers';
    import NativeHtmlEmbedContent from './variations/NativeHtmlEmbedContent.svelte';
    import PredefinedEmbeds from './variations/PredefinedEmbeds.svelte';
    import SandboxedHtmlEmbedContent from './variations/SandboxedHtmlEmbedContent.svelte';
    import Box from '../_wrappers/Box.svelte';

    import type { TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    // General note:
    // Embed for "custom-html" providers shall be either embedded in a separate
    // cross-origin "sandbox" iframe or natively.
    //
    // This is not necessary/wanted for the other embeds (like Google, ProvenExpert, etc.).
    // That's why I (Peter) favored separate component implementations instead
    // of one big generic component to keep things simple.
    //
    // Now we have SandboxedHtmlEmbedContent, NativeHtmlEmbedContent and
    // PredefinedEmbeds (like Google Maps, Proven Expert, etc.).

    export let id = '';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let box = {};
    export let bgColor = 'transparent';
    export let provider = '';
    export let head = '';
    export let body = '';
    export let embedCustomHtmlNatively = false;
    export let campaignId: string;
    export let trackingProperties: TrackingProperty[];
    export let globalVariables: Record<string, string> = {};
</script>

{#if head || body}
    <Box {id} {...box} backgroundColor={bgColor} {transitionDelay} {transitionEffect}>
        {#if provider === 'custom-html' && embedCustomHtmlNatively}
            <NativeHtmlEmbedContent
                {...$$props}
                {...interpolateHeadAndBody(trackingProperties, globalVariables, campaignId, {
                    head,
                    body,
                })}
            />
        {:else if provider === 'custom-html' && !embedCustomHtmlNatively}
            <SandboxedHtmlEmbedContent
                {...$$props}
                {...interpolateHeadAndBody(trackingProperties, globalVariables, campaignId, {
                    head,
                    body,
                })}
            />
        {:else}
            <PredefinedEmbeds {...$$props} />
        {/if}
    </Box>
{/if}
